import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Sector } from '../models/Sector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_API } from '../global/config'


@Injectable({
  providedIn: 'root'
})
export class SectorService {

  //private urlEndpoint: string = 'http://localhost:3000/api/v1/sectores';
  private urlEndpoint: string = URL_API.UrlApi+'/api/v1/sectores';

  //private urlEndpoint: string = 'http://172.16.7.144:3000/api/v1/sectores';
  //private urlEndpoint: string = 'http://192.168.1.15:3000/api/v1/sectores';

  constructor(
    private http: HttpClient
  ) { }

  getSectores(): Observable<Sector[]> {
    //return this.http.get<Sector[]>(this.urlEndpoint);
    return this.http.get(this.urlEndpoint).pipe(
      map((response) => response as Sector[])
    )
  }

}
